import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/reports/"
)({
  component: () => (
    <Navigate to="/finance/reports/$tabKey" params={{ tabKey: "overview" }} />
  ),
})
